// Reply-intent taxonomy — stolen from Reply.io's 6-category model + Stax-specific bucket.
// Source: docs/future_email_endeavors/email_platforms_landscape.md (synthesis section)

export const REPLY_INTENTS = [
  'interested',
  'not_interested',
  'not_now',
  'do_not_contact',
  'ooo',
  'forwarded',
  'question_needs_human',
] as const;

export type ReplyIntent = (typeof REPLY_INTENTS)[number];

export const INTENT_LABELS: Record<ReplyIntent, string> = {
  interested: 'Interested',
  not_interested: 'Not Interested',
  not_now: 'Not Now',
  do_not_contact: 'Do Not Contact',
  ooo: 'Out of Office',
  forwarded: 'Forwarded',
  question_needs_human: 'Question / Needs Human',
};

// Whether an intent is a candidate for auto-response (subject to confidence + escalation).
// `do_not_contact` and `question_needs_human` are NEVER auto-replied — humans only.
export const AUTO_REPLY_CANDIDATE: Record<ReplyIntent, boolean> = {
  interested: true,
  not_interested: true,
  not_now: true,
  do_not_contact: false,
  ooo: true,
  forwarded: false,
  question_needs_human: false,
};

export const ESCALATION_REASONS = [
  'low_confidence',
  'mentions_money',
  'mentions_contract',
  'mentions_pedro',
  'thread_too_long',
  'human_only_intent',
  'auto_send_disabled',
  'no_template',
  'classifier_failed',
] as const;

export type EscalationReason = (typeof ESCALATION_REASONS)[number];
